import React from 'react';
import { Helmet } from 'react-helmet-async';
interface SEOProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogImage?: string;
  structuredData?: object;
}
export function SEO({
  title,
  description,
  keywords,
  canonicalUrl,
  ogImage = 'https://cdn.magicpatterns.com/uploads/hvDwp8eai2TZvgE2zzHb3Q/DSC_9203_-_square.png',
  structuredData
}: SEOProps) {
  const fullTitle = `${title} | CRMReview.de`;
  const siteUrl = 'https://crmreview.de';
  const canonical = canonicalUrl ? `${siteUrl}${canonicalUrl}` : siteUrl;
  return <Helmet data-id="element-126">
      {/* Primary Meta Tags */}
      <title data-id="element-127">{fullTitle}</title>
      <meta name="title" content={fullTitle} data-id="element-128" />
      <meta name="description" content={description} data-id="element-129" />
      {keywords && <meta name="keywords" content={keywords} data-id="element-130" />}
      <link rel="canonical" href={canonical} data-id="element-131" />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" data-id="element-132" />
      <meta property="og:url" content={canonical} data-id="element-133" />
      <meta property="og:title" content={fullTitle} data-id="element-134" />
      <meta property="og:description" content={description} data-id="element-135" />
      <meta property="og:image" content={ogImage} data-id="element-136" />
      <meta property="og:locale" content="de_DE" data-id="element-137" />
      <meta property="og:site_name" content="CRMReview.de" data-id="element-138" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" data-id="element-139" />
      <meta property="twitter:url" content={canonical} data-id="element-140" />
      <meta property="twitter:title" content={fullTitle} data-id="element-141" />
      <meta property="twitter:description" content={description} data-id="element-142" />
      <meta property="twitter:image" content={ogImage} data-id="element-143" />

      {/* Language */}
      <meta httpEquiv="content-language" content="de" data-id="element-144" />
      <html lang="de" data-id="element-145" />

      {/* Structured Data */}
      {structuredData && <script type="application/ld+json" data-id="element-146">
          {JSON.stringify(structuredData)}
        </script>}
    </Helmet>;
}